import { db } from "../../../../mp-database"
import parseSnapshot from "../../parseSnapshot"
import { values } from "mout/object"

/**
 * Fetches all of the scoring object data associated with a uA
 * @param {string} userAssessmentId id of the userAssessment
 * @param {string} userId id of the user who owns the userAssessment
 * @returns {object} scoring {byItem, byNode, bySubtest, byTest}
 */
export default function getScoring(userAssessmentId, userId) {
  let scoring = {
    byItem: {},
    byNode: {},
    bySubtest: {},
    byTest: {}
  }
  const byNode = getByNode(userAssessmentId)
  const byItem = getByItem(userAssessmentId)
  const bySubtest = getBySubtest(userAssessmentId, userId)
  const byTest = getByTest(userAssessmentId)
  return Promise.all([byNode, byItem, bySubtest, byTest]).then(results => {
    const [byNode, byItem, bySubtest, byTest] = results
    scoring.byNode = byNode
    scoring.byItem = byItem
    scoring.bySubtest = bySubtest
    scoring.byTest = byTest
    return scoring
  })
}

// fetches byTest data
function getByTest(userAssessmentId) {
  return db
    .collection("scoringByTest")
    .doc(userAssessmentId)
    .get()
    .then(doc => {
      const byTest = doc.data()
      return byTest ? byTest.byTest : {}
    })
}

// fetches bySubtest data
function getBySubtest(userAssessmentId, userId) {
  let query = db
    .collection("scoringBySubtest")
    .where("userAssessmentId", "==", userAssessmentId)

  if (userId) {
    query = query.where("userId", "==", userId)
  }

  return query
    .get()
    .then(querySnapshot => {
      const bySubtest = values(parseSnapshot(querySnapshot))
      let bySubtestOutput = {}
      bySubtest.forEach(subtest => {
        bySubtestOutput[subtest.subtestId] = subtest.bySubtest
      })
      return bySubtestOutput
    })
}

// fetches byItem data
function getByItem(userAssessmentId) {
  return db
    .collection("scoringByItem")
    .where("userAssessmentId", "==", userAssessmentId)
    .get()
    .then(querySnapshot => {
      const byItem = values(parseSnapshot(querySnapshot))
      let byItemOutput = {}
      byItem.forEach(subtestByItem => {
        byItemOutput[subtestByItem.subtestId] = subtestByItem.byItem
      })
      return byItemOutput
    })
}

// fetches byNode data
function getByNode(userAssessmentId) {
  return db
    .collection("scoringByNode")
    .where("userAssessmentId", "==", userAssessmentId)
    .get()
    .then(querySnapshot => {
      const byNode = parseSnapshot(querySnapshot)
      const byNodeData = values(byNode)
      let byNodeOutput = {}
      byNodeData.forEach(nodeData => {
        byNodeOutput[nodeData.subtestId] = nodeData.byNode
      })
      return byNodeOutput
    })
}
